// extracted by mini-css-extract-plugin
export default {"NavBtn":"Navigation_NavBtn__dWQF+","Logo":"Navigation_Logo__jRe7V"};